"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.BackIcon = exports.ListItem = exports.Link = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var _ArrowLeft = _interopRequireDefault(require("@paprika/icon/lib/ArrowLeft"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Link = _styledComponents["default"].a.withConfig({
  displayName: "Linkstyles__Link",
  componentId: "sc-9xvxo8-0"
})(function (_ref) {
  var isDark = _ref.isDark;
  return (0, _styledComponents.css)(["", " ", " color:", ";display:inline;font-weight:normal;margin:0 ", ";min-height:0;padding:0 3px;text-decoration:none;vertical-align:top;"], _stylers["default"].lineHeight(), _stylers["default"].fontSize(-2), isDark ? _tokens["default"].color.white : _tokens["default"].textColor.subtle, _tokens["default"].spaceSm);
});

exports.Link = Link;

var ListItem = _styledComponents["default"].li.withConfig({
  displayName: "Linkstyles__ListItem",
  componentId: "sc-9xvxo8-1"
})(function (_ref2) {
  var isUsingDefaultLinkComponent = _ref2.isUsingDefaultLinkComponent;
  return (0, _styledComponents.css)(["display:inline;list-style-type:none;margin:0;padding:0;&::before{content:\"/\";}&:first-child{margin-left:", ";}&:first-child::before{display:none;}"], isUsingDefaultLinkComponent ? "-".concat(_tokens["default"].space) : "-7px");
});

exports.ListItem = ListItem;
var BackIcon = (0, _styledComponents["default"])(_ArrowLeft["default"]).withConfig({
  displayName: "Linkstyles__BackIcon",
  componentId: "sc-9xvxo8-2"
})(["", ";margin:1px ", " 0 0;"], _stylers["default"].fontSize(-1), _tokens["default"].spaceSm);
exports.BackIcon = BackIcon;
//# sourceMappingURL=Link.styles.js.map